import { FormBuilder, FormGroup, Validators } from "@angular/forms";

export interface didgroup {
    id: number;
    name: string;
}

export interface HTTPGrouplist {
    name: string;
    id:number
}

export class didgroupForm implements HTTPGrouplist {
    public name: string;
    public id:number
    constructor(data: didgroup) {
        if (data == null) {
            this.name = "";
        }
        else {
            this.id=data.id
            this.name = data.name;
        }
    }

    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            name: [this.name,  [Validators.required]],
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.name = fg.get("name").value;
            return true;
        }
        else {
            return false;
        }
    }
}
